import React, {Component} from 'react'
import i18 from '../../i18'
import api from '../../source/api'
import Modal from 'react-modal'
import Field from '../common/Field'
import Validator from '../common/Validator'

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

Modal.setAppElement('#root');

class SupplierRules extends Component {

    constructor(props) {
        super(props);
        this.state = {
            config: props.config,
            supplierRules: props.supplierRules,
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            supplierRules: nextProps.supplierRules,
        })
    }

    onRemoveRule = (rule) => {
        if (!window.confirm('Biztos törölni szeretné a szabályt?')) {
            return
        }

        api.delete('supplier/' + this.state.config.company_id + '/rule/delete/' + rule.id)
            .then((response) => {
                this.props.updateRules(response.data.supplierRules);
                this.props.notifySuccess('Szabály törlése sikeres.');
            })
            .catch((err) => {
                this.props.notifyError('Szabály törlése sikertelen.');
            });
    };

    printPage = () => {
        window.print();
    };

    deleteAllRules = () => {
        if (!window.confirm('Biztos törölni szeretné az összes szabályt?')) {
            return;
        }

        api.delete('supplier/' + this.state.config.company_id + '/rules/delete-all')
            .then((response) => {
                this.props.updateRules(response.data.supplierRules);
                this.props.notifySuccess('Az összes szabály törölve lett.');
            })
            .catch((err) => {
                this.props.notifyError('Szabályok törlése sikertelen.');
            });
    };

    renderRulesTableHeader = () => {
        return (
            <tr>
                <th>{i18.COMMON._identifier}</th>
                <th>{i18.SUPPLIER._supplierName}</th>
                <th>{i18.SUPPLIER._typeOfTraffic}</th>
                <th>{i18.SUPPLIER._mainBookNumber}</th>
                <th>{i18.SUPPLIER._VAT}</th>
                <th>{i18.SUPPLIER._collectorCode}</th>
                <th>{i18.SUPPLIER._taxNumber}</th>
                <th>{i18.COMMON._typeOfRule}</th>
                <th>{i18.COMMON._updatedAt}</th>
                <th style={{width: '70px'}}></th>
            </tr>
        );
    }

    renderRulesTableRow = (rule) => {
        return <tr key={'supplier-rule-' + rule.id}>
            <td>#{rule.id}</td>
            <td>{rule.supplier_name || '-'}</td>
            <td>{rule.item_name || '-'}</td>
            <td>{rule.main_bookkeeping_number}</td>
            <td>{rule.vat}%</td>
            <td>{rule.vat_collector_code}</td>
            <td>{rule.vat_degree}</td>
            <td>{rule.type_label}</td>
            <td>{rule.updated_at}</td>
            <td>
                <i onClick={() => this.props.editRule(rule)} title={i18.SUPPLIER._editRule} className='fa fa-pencil-square-o' aria-hidden='true'></i> &nbsp;&nbsp;
                <i onClick={() => this.onRemoveRule(rule)} title={i18.SUPPLIER._deleteRule} className='fa fa-trash-o' aria-hidden='true'></i>
            </td>
        </tr>;
    };

    render() {
        return (
            <section id='supplier-rules'>
                <div className='header'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <h1>
                                    <a onClick={() => this.props.toggleRulesPage()} className='choose-btn'>{i18.BUTTONS._back}</a>
                                    {i18.SUPPLIER._rulesTitle}
                                </h1>
                                <h4 className='text-left'>Kiválasztott cég : {typeof this.state.company !== 'undefined' ? this.state.company.name : ''}</h4>
                            </div>
                            <div className='col-12'>
                                <p>{i18.SUPPLIER._rulesDescription}</p>
                                <a className='link-color mr-2' onClick={() => this.printPage()}>
                                    <i className="fa fa-print" aria-hidden="true"/>&nbsp;{i18.COMMON._printRules}
                                </a>
                                <a className='link-color' onClick={() => this.deleteAllRules()}>
                                    <i className="fa fa-trash-o" aria-hidden="true"/>&nbsp;{i18.COMMON._deleteAllRules}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='body'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <table className='table table-striped table-aibook-no-border'>
                                    <thead>
                                    {this.renderRulesTableHeader()}
                                    </thead>
                                    <tbody>
                                    {this.state.supplierRules.map((rule) => this.renderRulesTableRow(rule))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    };
}

export default SupplierRules;




// WEBPACK FOOTER //
// ./src/components/supplier/SupplierRules.js